import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { FechasService } from 'src/app/services/fechas/fechas';
import { ImprimiService } from 'src/app/services/imprimir/imprimirService';
import { ImprimirMultipleService } from 'src/app/services/imprimirMultiples/imprimirMultipleService';
import { FirmaService } from 'src/app/services/firma/firmaService';
import { estilos_informes } from 'src/app/config/estilos-informes';

declare var $:any;



@Component({
  selector: 'app-imprimir-multiple-control',
  templateUrl: './imprimir-control.component.html',
  styleUrls: ['./imprimir-control.component.css'],
  providers:[ImprimiService,FirmaService]
  
})
export class ImprimirMultipleControlComponent implements OnInit{
   
   
    

    @Input() title:string;
    @Input() producto:any[]=[];
    @Input() database:string="";
    @Output() cerrarVentana = new EventEmitter();

    public productos:any[]=[];
    public anexo:Date[]=[];
    public productosKey:any[]=[];
    public estructurado:any[]=[];
    public fechaActual=this.fechaService.mostrarFechaActual();
    public closeWindow=true;
    public check="https://demo.qualitapp.com/ws/upload/mark.png";
    public cancel="https://demo.qualitapp.com/ws/upload/cancel.png";
    public firma: string[] = [];
    public baseUrl = "https://demo.qualitapp.com/ws/upload/firmas/";
   
    constructor(
        private fechaService:FechasService,
        private imprimirService:ImprimiService,
        private imprimirMultipleServcie:ImprimirMultipleService, 
        private firmaService : FirmaService
        
        ){
        this.productos = this.producto;
         
          
    }
   public myMap=new Map([]);
    ngOnInit(): void {
       this.imprimirMultipleServcie.mostrarProductos.subscribe(resp=>{
           //console.log("respuesta ",resp.productos);
           this.productos = resp.productos;
           // this.MostrarAnexo();
           // this.mostrarFirma();
       },error=>{
           console.log("error",error);
           
       });
        //console.log("productos",this.productos);
    }
     mostrarFirma() { 
        this.firma = [];
        for (let index = 0; index < this.productos.length; index++) {
            
            
            this.firmaService.getFirma(this.productos[index].revisado_nombre).toPromise().then((data:any)=>{
               try {
                if(data.productos[0].firma!=undefined){
                    this.firma.push(this.baseUrl+data.productos[0].firma);
        
                }else{
                    //console.log("no hay firma");
                    
                   this.firma.push(null); 
                }
               } catch (error) {
                this.firma.push(null); 
               }
                
                
            }).then(()=>{
                
            }).catch(error=>{
                console.log("error ",error);
                
            }); 
            
        }
       
        //console.log("firma",this.firma);
        
       
    }

   MostrarAnexo() {
       this.anexo = [];
    //console.log("productos length",this.productos.length);
     
   for (let index = 0; index < this.productos.length; index++) {
   
      let separarFEcha=this.productos[index]['fecha'].split("/");

      let estructurarFEcha=separarFEcha[2]+"-"+separarFEcha[1]+"-"+separarFEcha[0];
      //console.log("estructurarFEcha",estructurarFEcha);
  

        //  console.log("estructura",estructurarFEcha,"database",this.database)
        this.imprimirService.getAnexo(estructurarFEcha,this.database).toPromise().then((resp:any)=>{
            //console.log("anexo",resp.producto[0]);
           
            try {
                if(resp.producto[0]['fecha_anexo']===undefined||resp.producto[0]['fecha_anexo'].length<=0){
                    this.anexo.push(new Date());
                }else{
                    this.anexo.push(resp.producto[0]['fecha_anexo']);
                }
            } catch (error) {
                this.anexo.push(new Date());
            }
 
        }).catch(error=>{console.log("error anexo", error);
        });
     
   }
   }
   jsUcfirst(string) 
   {
       return string.charAt(0).toUpperCase() + string.slice(1);
   }

 Export2Doc(){
    
    
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title>"
    + "<style>" + estilos_informes + "<div style=' font-family: Arial; font-size: 12px;'>";
    var postHtml = "</div></body></html>";
    var html = preHtml+document.getElementById('source-html').innerHTML+postHtml;

    var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
    });
    
    // Specify link url
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    let filename="";
    // Specify file name
    filename = filename?filename+'.doc':'Control de etiquetas.doc';
    
    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);
    
    if(navigator.msSaveOrOpenBlob ){
        navigator.msSaveOrOpenBlob(blob, filename);
    }else{
        // Create a link to the file
        downloadLink.href = url;
        
        // Setting the file name
        downloadLink.download = filename;
        
        //triggering the function
        downloadLink.click();
    }
    
    document.body.removeChild(downloadLink);
}

  cerrar(){
      this.cerrarVentana.emit({ closeWindow:false});
  }

 
    

  

}